import { Component, OnInit, Inject } from '@angular/core';
import { Globals } from '../../../../globals'
import { ISpedStudentDemographics } from '../../../../Models/ISpedStudentDemographics'
import { IIepInstance } from '../../../../Models/IIepInstance'
import { IepService } from "../../../../Services/IepService";
import { ILockStatus } from '../../../../Models/ILockStatus';
import { Message, SelectItem } from 'primeng/primeng';
import { Router } from "@angular/router";
import { ILookupBase, ILookupBaseWithValue } from '../../../../Models/ILookupBase';
import { LookupService } from 'src/app/Services/LookupService';
import { IIepServiceInfo } from '../../../../Models//IIepServiceInfo';
import { LookupTypeEnum } from 'src/app/Models/Enums/LookupTypeEnum';
import { FormStudentInformationService } from "../../../../Services/FormStudentInformationService";
import { IFormStudentInformation } from "../../../../Models/Forms/IFormStudentInformation"
import { IReportParameter } from 'src/app/Models/IReportParameter';
import { ReportService } from '../../../../Services/ReportService'; 
import { SpinnerBase } from '../../../Base/SpinnerBase';
import { StudentService } from "../../../../Services/StudentService";
import { DashboardDocumentService } from "../../../../Services/DashboardDocumentService";
import { ISelectedStudent } from 'src/app/Models/ISelectedStudent'
import { ISpedStudentContact } from '../../../../Models/ISpedStudentContact';
//import { Date } from 'core-js';

@Component({
  selector: 'StudentInformation',
  templateUrl: './StudentInformation.component.html',
  styleUrls: ['./StudentInformation.component.css']

})
export class FormStudentInformationComponent extends SpinnerBase implements OnInit {
  _myGlobals: Globals;
  _baseUrl: string;
  _iepService: IepService;
  _studentService: StudentService;
  _dashboardDocumentService: DashboardDocumentService;
  successMessages: Message[];
  errorMessages: Message[];
  studentInfo: ISpedStudentDemographics;
  selectedIepInstance: IIepInstance;
  isLocked: boolean;
  isELDServiceDeliveryGeneralEd: boolean;
  isELDServiceDeliverySpeciallEd: boolean;
  lockStatus: string;
  canEditIep: boolean;
  saveClicked: boolean;
  formStudentInformationDB: any = [];
  _lookupService: LookupService;
  lookupDisabilityList: ILookupBase[];
  lookupDegreeOfSupportList: SelectItem[];
  lookupExitReasonList: ILookupBase[];
  lookupServiceList: ILookupBase[];
  spedServiceList: ILookupBase[];
  spedServiceListIncludeDisabled: ILookupBase[];
  lookupServiceDurationList: ILookupBase[];
  lookupServiceLocationList: ILookupBase[];
  lookupServiceLocationListWithDisabled: ILookupBase[];
  lookupServiceFrequencyList: ILookupBase[];
  lookupServiceIndividualGroupList: ILookupBase[];
  lookupServiceIndividualGroupListWithDisabled: ILookupBase[];
  lookupCurriculumList: ILookupBase[];
  services: IIepServiceInfo[];
  newAttribute: IIepServiceInfo;
  rowNum: number;
  reportParamArray: IReportParameter[];
  requireDegreeOfSupportServiceList: string[];
  serviceStartDateMin: Date;
  serviceStartDateMax: Date;
  serviceEndDateMin: Date;
  serviceEndDateMax: Date;
  maxExitDate: Date;
  fapeEndDate: Date;
  displayRecommendationsParticipationPercentage = 0
  checkedTrue: boolean = true;
  checkedFalse: boolean = false;
  showPushInPullOut: boolean = false;
  lookupServiceDurationListWithValue: ILookupBaseWithValue[];
  lookupServiceFrequencyListWithValue: ILookupBaseWithValue[];

  constructor(
    private globals: Globals,
    iepService: IepService,
    @Inject('BASE_URL') baseUrl: string,
    public router: Router,
    lookupService: LookupService,
    reportService: ReportService,
    studentService: StudentService,
    dashboardDocumentService: DashboardDocumentService,
    private _frmStudentInformationService: FormStudentInformationService) {
    super(reportService);
    this._iepService = iepService;
    this._myGlobals = globals;
    this._baseUrl = baseUrl;
    this.studentInfo = this._myGlobals.spedStudentDemographics;
    this.selectedIepInstance = this._myGlobals.selectedIepInstance;
    this._lookupService = lookupService;
    this._studentService = studentService;
    this._dashboardDocumentService = dashboardDocumentService;
    this.fapeEndDate = new Date(this._myGlobals.selectedIepInstance.meetingDate.getFullYear() + 1, this._myGlobals.selectedIepInstance.meetingDate.getMonth(), this._myGlobals.selectedIepInstance.meetingDate.getDate() - 1);
  }

  ngOnInit(): void {
    this.LoadFormStudentInformationDetails();
    this.isLocked = false;
    this.canEditIep = this._myGlobals.canEdit();
    this.scrollToTop();

    this.buildRequiredDisabiltiyList();
    this.serviceStartDateMin = this._myGlobals.selectedIepInstance.meetingDate;
    this.serviceStartDateMax = this._myGlobals.selectedIepInstance.annualDueDate;
    this.serviceEndDateMin = this._myGlobals.selectedIepInstance.meetingDate;
    this.serviceEndDateMax = this._myGlobals.selectedIepInstance.annualDueDate;
    let iepDate = this._myGlobals.selectedIepInstance.meetingDate;
    this.maxExitDate = new Date(iepDate.getFullYear() + 1, iepDate.getMonth(), iepDate.getDate() - 1);

    this.successMessages = [];
    this.errorMessages = [];
  }

  buildRequiredDisabiltiyList() {
    this.requireDegreeOfSupportServiceList = ['210', '260', '270', '280', '290', '300', '310', '320', '330', '331', '332'];
  }

  LoadFormStudentInformationDetails(): void {
    this._frmStudentInformationService.getFormStudentInformation(this._myGlobals.selectedFormDetails.formId)
      .subscribe((res: IFormStudentInformation) => {
        this.formStudentInformationDB = res
        this.formStudentInformationDB.eligibilityNotEligible = res.eligibilityNotEligible == null ? false : res.eligibilityNotEligible;
        this.formStudentInformationDB.exitedReason = res.exitedReason == null ? '' : res.exitedReason.toString();
        this.formStudentInformationDB.revokeReasonId = res.revokeReasonId == null ? '' : res.revokeReasonId.toString();
        //convert percentage float into more friendly display value
        this.displayRecommendationsParticipationPercentage = this.formStudentInformationDB.recommendationsParticipationPercentage * 100;

        //LoadServicesValues
        this.rowNum = 1;
        this.services = res.serviceInformationList.map(o => {
          return {
            id: o.id,
            localStudentId: o.localStudentId,
            serviceId: o.starSpecialEducationService_Id?.toString(),
            duration: o.duration?.toString(),
            location: o.location?.toString(),
            frequency: o.frequency?.toString(),
            individualGroup: o.individualGroup?.toString(),
            pushInPullOut: o.pushInPullOut,
            startDate: o.startDate == null ? new Date(this._myGlobals.selectedIepInstance.meetingDate) : new Date(o.startDate),
            endDate: o.endDate == null ? null : new Date(o.endDate),
            removed: o.removed,
            offerOfFapeStartDate: o.offerOfFapeStartDate == null ? this._myGlobals.selectedIepInstance.meetingDate : o.offerOfFapeStartDate,
            offerOfFapeEndDate: o.offerOfFapeEndDate == null ? this.fapeEndDate : o.offerOfFapeEndDate,
            offerOfFapeEndDateString: o.offerOfFapeEndDateString == null ? this.fapeEndDate.toLocaleDateString() : o.offerOfFapeEndDateString,
            serviceDuration: o.serviceDuration,
            sortOrder: o.sortOrder,
            starIepPage1_Id: o.starIepPage1_Id,
            iPAddress: o.iPAddress,
            updatedOn: o.updatedOn,
            rowNumber: this.rowNum++,
          };
        });

        let servicesWithPushInPullOutList = this.services.filter(x => x.pushInPullOut)
        if (this.services && this.services.length > 0 && servicesWithPushInPullOutList.length > 0) {
          this.showPushInPullOut = true;
        }
        else {
          this.showPushInPullOut = false;
        }

        this.LoadLookupValues();

        this.formStudentInformationDB.annualDueDate = this.formStudentInformationDB.annualDueDate == null ? null : new Date(this.formStudentInformationDB.annualDueDate);
        this.formStudentInformationDB.iepMeetingDate = this.formStudentInformationDB.iepMeetingDate == null ? null : new Date(this.formStudentInformationDB.iepMeetingDate);
        this.formStudentInformationDB.initialConsentDate = this.formStudentInformationDB.initialConsentDate == null ? null : new Date(this.formStudentInformationDB.initialConsentDate);
        this.formStudentInformationDB.initialIepDate = this.formStudentInformationDB.initialIepDate == null ? null : new Date(this.formStudentInformationDB.initialIepDate);
        this.formStudentInformationDB.initialReferralDate = this.formStudentInformationDB.initialReferralDate == null ? null : new Date(this.formStudentInformationDB.initialReferralDate);
        this.formStudentInformationDB.initialServiceDate = this.formStudentInformationDB.initialServiceDate == null ? null : new Date(this.formStudentInformationDB.initialServiceDate);
        this.formStudentInformationDB.exitedDate = this.formStudentInformationDB.exitedDate == null ? null : new Date(this.formStudentInformationDB.exitedDate);
        this.formStudentInformationDB.permissionRevokedDate = this.formStudentInformationDB.permissionRevokedDate == null ? null : new Date(this.formStudentInformationDB.permissionRevokedDate);
        this.formStudentInformationDB.triennialDueDate = this.formStudentInformationDB.triennialDueDate == null ? null : new Date(this.formStudentInformationDB.triennialDueDate);

        if (this.formStudentInformationDB.languageProficiency == null) {
          switch (this._myGlobals.selectedStudent.elStatus.toLowerCase()) {
            case "eo":
              this.formStudentInformationDB.languageProficiency = 1;
              break;
          }
        }

        if (this.formStudentInformationDB.applicationErrors != '') {
          let errorMessage: Message = { severity: 'error', summary: 'Correct error', detail: this.formStudentInformationDB.applicationErrors };
          this.addMessage(errorMessage);
        }

      },
        err => console.error(err)
      );
  }

  LoadLookupValues() {
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.Disability]).subscribe((res: ILookupBase[]) => {
      this.lookupDisabilityList = [{ value: null, label: "[Select One]", shortText: null, updatedOn: null }].concat(res);;
    },
      err => console.error(err)
    );

    this.lookupDegreeOfSupportList = [
      { value: null, label: '[Select One]' },
      { value: 1, label: 'Mild to Moderate Support Needs' },
      { value: 2, label: 'Extensive Support Needs' }
      //Mild to Moderate Support Needs
    ]

    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.ExitReason]).subscribe((res: ILookupBase[]) => {
      this.lookupExitReasonList = [{ value: null, label: "[Select One]", shortText: null, updatedOn: null }].concat(res);;
    },
      err => console.error(err)
    );

    //services
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.SPEDService]).subscribe((res: ILookupBase[]) => {
      this.spedServiceList = res.map(o => {
        return {
          value: o.value,
          label: o.value + " " + o.label,
          shortText: o.shortText,
          updatedOn: o.updatedOn,
        };
      });
      this.lookupServiceList = [{ value: null, label: "[Select One]", shortText: null, updatedOn: null }].concat(this.spedServiceList);;

      //to avoid race conditions including disabled is nested; this method should propably not bein nesting inside loading the form
      this._lookupService.getLookupArray(this._baseUrl + `api/Lookup/GetLookupList?lookupTableName=${LookupTypeEnum[LookupTypeEnum.SPEDServiceIncludeDisabled]}`).subscribe(
        (res: ILookupBase[]) => {
          this.spedServiceListIncludeDisabled = res.map(o => {
            return {
              value: o.value,
              label: o.value + " " + o.label,
              shortText: o.shortText,
              updatedOn: o.updatedOn,
            };
          });

          if (this.services) {
            let existingServiceValues = this.services.map(s => s.serviceId);
            let lookupServiceValues = this.spedServiceList.map(l => l.value);
            existingServiceValues.forEach((item: string) => {
              if (lookupServiceValues.indexOf(item) === -1) {

                //get disabled item
                let disabledService = this.spedServiceListIncludeDisabled.find(s => s.value === item);
                if (disabledService) {
                  this.lookupServiceList.push({
                    value: disabledService.value,
                    label: disabledService.label,
                    shortText: disabledService.shortText,
                    updatedOn: disabledService.updatedOn
                  });
                  lookupServiceValues.push(disabledService.value); //avoid duplicate additions
                }
              }
            })

            this.lookupServiceList = [...this.lookupServiceList];
          }
        }
      );
    },
      err => console.error(err)
    );

    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.ServiceDuration]).subscribe((res: ILookupBase[]) => {
      this.lookupServiceDurationList = [{ value: null, label: "[Select One]", shortText: null, updatedOn: null }].concat(res);
    },
      err => console.error(err)
    );

    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.ServiceLocation]).subscribe((res: ILookupBase[]) => {
      this.lookupServiceLocationList = [{ value: null, label: "[Select One]", shortText: null, updatedOn: null }].concat(res);

      //to avoid race conditions including disabled is nested; this method should propably not bein nesting inside loading the form
      this._lookupService.getLookupArray(this._baseUrl + `api/Lookup/GetLookupList?lookupTableName=${LookupTypeEnum[LookupTypeEnum.ServiceLocationIncludeDisabled]}`).subscribe(
        (res: ILookupBase[]) => {
          this.lookupServiceLocationListWithDisabled = res;

          if (this.services) {
            let existingLocationValues = this.services.map(s => s.location);
            let lookupLocationValues = this.lookupServiceLocationList.map(l => l.value);
            existingLocationValues.forEach((item: string) => {
              if (lookupLocationValues.indexOf(item) === -1) {

                //get disabled item
                let disabledLocation = this.lookupServiceLocationListWithDisabled.find(ld => ld.value = item);
                if (disabledLocation) {
                  this.lookupServiceLocationList.push({ value: disabledLocation.value, label: disabledLocation.label, shortText: disabledLocation.shortText, updatedOn: disabledLocation.updatedOn });
                  lookupLocationValues.push(disabledLocation.value); //avoid duplicate additions
                }
              }
            })

            this.lookupServiceLocationList = [...this.lookupServiceLocationList];
          }
        }
      );
    },
      err => console.error(err)
    );

    

    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.ServiceFrequency]).subscribe((res: ILookupBase[]) => {
      this.lookupServiceFrequencyList = [{ value: null, label: "[Select One]", shortText: null, updatedOn: null }].concat(res);
    },
      err => console.error(err)
    );

    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.ServiceIndividualGroup]).subscribe((res: ILookupBase[]) => {
      this.lookupServiceIndividualGroupList = [{ value: null, label: "[Select One]", shortText: null, updatedOn: null }].concat(res);
      //to avoid race conditions including disabled is nested; this method should propably not bein nesting inside loading the form
      this._lookupService.getLookupArray(this._baseUrl + `api/Lookup/GetLookupList?lookupTableName=${LookupTypeEnum[LookupTypeEnum.ServiceIndividualGroupIncludeDisabled]}`).subscribe(
        (res: ILookupBase[]) => {
          this.lookupServiceIndividualGroupListWithDisabled = res;

          if (this.services) {
            let existingIndividualGroupValues = this.services.map(s => s.individualGroup);
            let lookupIndividualGroupValues = this.lookupServiceIndividualGroupList.map(l => l.value);
            existingIndividualGroupValues.forEach((item: string) => {
              if (lookupIndividualGroupValues.indexOf(item) === -1) {

                //get disabled item
                let disabledIndividualGroup = this.lookupServiceIndividualGroupListWithDisabled.find(ld => ld.value = item);
                if (disabledIndividualGroup) {
                  this.lookupServiceIndividualGroupList.push({ value: disabledIndividualGroup.value, label: disabledIndividualGroup.label, shortText: disabledIndividualGroup.shortText, updatedOn: disabledIndividualGroup.updatedOn });
                  lookupIndividualGroupValues.push(disabledIndividualGroup.value); //avoid duplicate additions
                }
              }
            })

            this.lookupServiceIndividualGroupList = [...this.lookupServiceIndividualGroupList];
          }
        }
      );
    },
      err => console.error(err)
    );

    this._lookupService.getLookupArray(this._baseUrl + `api/Lookup/GetLookupList?lookupTableName=${LookupTypeEnum[LookupTypeEnum.ServiceIndividualGroupIncludeDisabled]}`).subscribe(
      (res: ILookupBase[]) => {
        this.lookupServiceIndividualGroupListWithDisabled = res;
      }
    );

    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.Curriculum]).subscribe((res: ILookupBase[]) => {
      this.lookupCurriculumList = [{ value: null, label: "[Select One]", shortText: null, updatedOn: null }].concat(res);
    },
      err => console.error(err)
    );

    this._lookupService.getLookupBaseServiceDurationList(this._baseUrl + 'api/Lookup/GetLookupServiceDurationList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.ServiceDuration]).subscribe((res: ILookupBaseWithValue[]) => {
      this.lookupServiceDurationListWithValue = res.map(o => {
        return {
          value: o.value,
          label:  o.label,
          lookupValue: o.lookupValue,
        };
      });
    },
      err => console.error(err)
    );

    this._lookupService.getLookupBaseServiceFrequencyList(this._baseUrl + 'api/Lookup/GetLookupServiceFrequencyList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.ServiceFrequency]).subscribe((res: ILookupBaseWithValue[]) => {
      this.lookupServiceFrequencyListWithValue = res.map(o => {
        return {
          value: o.value,
          label:  o.label,
          lookupValue: o.lookupValue,
        };
      });
    },
      err => console.error(err)
    );

  }

  newRow() {

    let fapeEndDate = new Date(this._myGlobals.selectedIepInstance.meetingDate.getFullYear() + 1, this._myGlobals.selectedIepInstance.meetingDate.getMonth(), this._myGlobals.selectedIepInstance.meetingDate.getDate());

    this.services.push({
      id: 0,
      localStudentId: this.studentInfo.localStudentId,
      serviceId: null,
      duration: null,
      location: null,
      frequency: null,
      individualGroup: null,
      pushInPullOut: '',
      startDate: this._myGlobals.selectedIepInstance.meetingDate,
      endDate: null,
      removed: null,
      offerOfFapeStartDate: this._myGlobals.selectedIepInstance.meetingDate,
      offerOfFapeEndDate: this.fapeEndDate,
      offerOfFapeEndDateString: fapeEndDate.toLocaleDateString(),
      serviceDuration: null,
      sortOrder: null,
      starIepPage1_Id: null,
      iPAddress: null,
      updatedOn: null,
      rowNumber: this.rowNum++ ,
    })
  }

  clearMessages() {
    this.successMessages = [];
    this.errorMessages = [];
  }

  addMessage(msg: Message) {
    if (msg.severity == 'error') {
      this.errorMessages = [...this.errorMessages, msg];
    }
    else {
      this.successMessages = [...this.successMessages, msg];
    }
  }

  loadUnLock(action) {
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=' + action)
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
      },
        err => console.error(err)
      );
  }

  edit() {
    this.clearMessages();
    this.saveClicked = false;
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=Lock')
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
        if (this.isLocked == true) {
          this.globals.editMode = true;
        }
        else {
          let failedMessage: Message = { severity: 'warn', summary: this.lockStatus }
          this.addMessage(failedMessage);
        }
      });
  }

  saveStudentServices() {
    this.formStudentInformationDB.serviceInformationList = this.services.map(o => {
      return {
        id: o.id,
        localStudentId: o.localStudentId,
        starSpecialEducationService_Id: parseInt(o.serviceId),
        duration: parseInt(o.duration),
        location: parseInt(o.location),
        frequency: parseInt(o.frequency),
        individualGroup: parseInt(o.individualGroup),
        pushInPullOut: o.pushInPullOut,
        startDate: o.startDate ? new Date(o.startDate) : o.startDate,
        endDate: o.endDate ? new Date(o.endDate) : o.endDate,
        removed: o.removed,
        offerOfFapeStartDate: o.offerOfFapeStartDate,
        offerOfFapeEndDate: o.offerOfFapeEndDate,
        serviceDuration: o.serviceDuration,
        sortOrder: o.sortOrder,
        starIepPage1_Id: o.starIepPage1_Id,
        iPAddress: o.iPAddress,
        updatedOn: o.updatedOn,
      };
    });
  }

  //Save the
  save(action) {
    this.scrollToTop();
    this.clearMessages();
    this.saveClicked = true;
    this.showSpinner = true;
    this.saveStudentServices()

    //save selected parent to appropriate column
    let selectedContact: ISpedStudentContact;
    if (this.formStudentInformationDB && this.formStudentInformationDB?.spedStudentDemographic && this.formStudentInformationDB?.spedStudentDemographic?.studentContacts && this.formStudentInformationDB?.spedStudentDemographic?.studentContacts?.length > 0) {
      for (let con of this.formStudentInformationDB.spedStudentDemographic.studentContacts) {
        if (con.isSelected) {
          selectedContact = con;
          this.formStudentInformationDB.parentGuardianName = `${selectedContact.firstName} ${selectedContact.lastName}`;
          console.log("found: " + this.formStudentInformationDB.parentGuardianName)
          break;
        }
      }
    }

    //update values
    this._frmStudentInformationService.insertUpdateFormStudentInformation(this.formStudentInformationDB)
      .subscribe((res: IFormStudentInformation) => {
        let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: res.id.toString() }
        this.addMessage(successMessage);
        if (action == 'Close') {
          this.globals.editMode = false;
          this.loadUnLock("UnLock");
        }
        this.saveClicked = false
        this.showSpinner = false;
        this.LoadFormStudentInformationDetails();
        this.validateForm();

        // the purpose of retreiving selectedStudent is so the Primary Disability on Student search remains in sync when the disability is changed on this form
        this._studentService.get(this._baseUrl + 'api/Student/' + this._myGlobals.selectedStudent.localStudentId).subscribe((res: ISelectedStudent) => {
          this._myGlobals.selectedStudent = res
        },
          err => console.error(err)
        );

        this._dashboardDocumentService.getIepStudent(this._baseUrl + 'api/DashboardDocument/GetIEPSpedStudentDemographics?iepInstanceId=' + this._myGlobals.selectedIepInstance.id).subscribe((res: ISpedStudentDemographics) => {
          this._myGlobals.spedStudentDemographics = res;
          this._myGlobals.spedStudentDemographics.dob = new Date(this._myGlobals.spedStudentDemographics.dob);
          this._myGlobals.spedStudentDemographics.meetingDate = this._myGlobals.spedStudentDemographics.meetingDate != null ? new Date(this._myGlobals.spedStudentDemographics.meetingDate) : null;
        },
          err => console.error(err)
        );
      },
        (error) => {
          let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
          this.addMessage(errorMessage);
          this.saveClicked = false;
          this.showSpinner = false;
        }
      )
  }

  validateForm() {
    this._frmStudentInformationService.validateForm(this._myGlobals.selectedFormDetails.formId).subscribe((res: string[]) => {
      for (var item of res) {
        let errorMessage: Message = { severity: 'error', summary: 'Validation Error', detail: item };
        this.addMessage(errorMessage);
      }
    },
      err => console.error(err)
    );
  }

  cancel() {
    this.clearMessages();
    this.globals.editMode = false;
    this.loadUnLock("UnLock");
    this.LoadFormStudentInformationDetails();
  }

  populateReportParameters() {
    this.reportParamArray = [];
    this.reportParamArray.push(
      { parameterName: 'dtFrmEdited', parameterValue: this.formStudentInformationDB.updatedOn.toString() },
      { parameterName: 'RequestID', parameterValue: '0' },
      { parameterName: 'isDraft', parameterValue: this._myGlobals.selectedDashboardDocument.status == 'Draft' ? 'True' : 'False'  },
      { parameterName: 'FormInstanceID', parameterValue: this.formStudentInformationDB.iepFormInstanceId.toString() },
      { parameterName: 'ShowCustomWaterMark', parameterValue: this._myGlobals.selectedDashboardDocument.status == 'Draft' ? 'true' : 'false' },
      { parameterName: 'CustomWatermarkText', parameterValue: 'DRAFT DRAFT DRAFT' },
      { parameterName: 'FormVersionID', parameterValue: '16' },
      { parameterName: 'BlankForm', parameterValue: 'false' },
      { parameterName: 'IEPID', parameterValue: this.formStudentInformationDB.iepId.toString()  },
      { parameterName: 'isAssessment', parameterValue: 'False' },
      { parameterName: 'Page1Id', parameterValue: this.formStudentInformationDB.id.toString() },
      { parameterName: 'PlanAddendumID ', parameterValue: '0' },
      { parameterName: 'AddendumDate', parameterValue: this._myGlobals.selectedIepInstance.addendumDate == null ? '0' : this._myGlobals.selectedIepInstance.addendumDate.toISOString().slice(0,10) }
    );
  }

  printEnglish() {
    this.populateReportParameters();
    this.printFormCommon(this.formStudentInformationDB.rdlFileNameEnglish, this.reportParamArray);
  }

  printSpanish() {
    this.populateReportParameters();
    this.printFormCommon(this.formStudentInformationDB.rdlFileNameSpanish, this.reportParamArray);
  }

  onReferralOtherSpecifyKeyUp() {
    if (this.formStudentInformationDB.referralOtherSpecify && this.formStudentInformationDB.referralOtherSpecify.length > 0) {
      this.formStudentInformationDB.referralOther = true;
    }
    else {
      this.formStudentInformationDB.referralOther = false;
    }
  }

  // This methos is used to remove service item and calculate participation percentage
  CancelSpecialEducationService(rowNumber : number)
  {
    this.services.find(s => s.rowNumber == rowNumber).removed = true;  
    this.CalculatParticipationPercentagee();  
  }

  // This method is used to  calculate participation percentage
  CalculatParticipationPercentagee(){
    var res: number = 0;

    // Foreach for all service items those are not removed
    this.services.forEach(item => {
      let durationIndex : number = this.lookupServiceDurationListWithValue.findIndex(s => s.value == item.duration && !item.removed);
      let frequencyIndex: number = this.lookupServiceFrequencyListWithValue.findIndex(s => s.value == item.frequency && !item.removed);
      let pullPushStatus: string = item.pushInPullOut //I push in; O push out; B both
      let locationIndex: number = this.lookupServiceLocationList.findIndex(s => s.value === item.location);
      // validating Duration & Frequency dropdowns selected or not
      if(durationIndex != -1 && frequencyIndex != -1 && locationIndex != -1)
      {
        let locationValue = this.lookupServiceLocationList[locationIndex].value
        if (!pullPushStatus && locationValue != '8') {
          //only id 8 for location are considered sped services
          var minutes: any = this.lookupServiceDurationListWithValue.find(s => s.value == item.duration).lookupValue;
          var frequencyPerWeek: any = this.lookupServiceFrequencyListWithValue.find(s => s.value == item.frequency).lookupValue;
          res = (res + (minutes * frequencyPerWeek));
        }
        else if (!pullPushStatus && locationValue === '8') {
          res = res;
        }
        else if (pullPushStatus) {
          //old rules should be used if push pull valud is present
          var minutes: any = this.lookupServiceDurationListWithValue.find(s => s.value == item.duration).lookupValue;
          var frequencyPerWeek: any = this.lookupServiceFrequencyListWithValue.find(s => s.value == item.frequency).lookupValue;
          res = (res + (minutes * frequencyPerWeek));
        }
      }
    });

    this.formStudentInformationDB.recommendationsParticipationPercentage = (res / 1500).toFixed(2);
    this.displayRecommendationsParticipationPercentage = this.formStudentInformationDB.recommendationsParticipationPercentage * 100;
    
  }

  onDisplayRecommendationsParticipationPercentageChanged(value) {
    console.log('function triggered')
    this.formStudentInformationDB.recommendationsParticipationPercentage = parseInt(value) / 100;
    console.log("percentage value: ", this.formStudentInformationDB.recommendationsParticipationPercentage);
  }
}
